<template>
  <div class="lazy-image" :class="rootClass">
    <img
      class="lazyimg"
      v-lazy="{ src: lazyimg, error: errorImg, loading: errorImg }"
    />
  </div>
</template>

<script>
// 统一的懒加载图片组件
// type 取值: 'avatar' | 'logo' | 'people'，分别对应 $lazy.error_avatar/logo/people
export default {
  name: 'LazyImage',
  props: {
    lazyimg: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'avatar',
      validator: (val) => ['avatar', 'logo', 'people'].includes(val),
    },
  },
  computed: {
    errorImg() {
      return this.$lazy[`error_${this.type}`]
    },
    rootClass() {
      return `lazy-image--${this.type}`
    },
  },
}
</script>

<style lang="less" scoped>
.lazy-image {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .lazyimg {
    width: 100%;
    height: 100%;
  }

  &--avatar {
    border-radius: 100%;
  }

  &--logo {
    display: flex;
    align-items: center;
    justify-content: center;
    .lazyimg {
      max-width: 100%;
      max-height: 100%;
      vertical-align: middle;
      text-align: center;
    }
  }

  &--people {
    position: relative;
    border-radius: 100%;
    .lazyimg {
      object-fit: cover;
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%;
      height: 100%;
    }
  }
}
</style>